export const DISADVANTAGED_COMMUNITY = 'disadvantaged community';

export const ASSISTANCE = 'assistance';

export const FILING_PREVIOUS_YEAR = 'filing (previous year)';

export const FILING_CURRENT_YEAR = 'filing (current / previous year)';

export const FIRST_TIME_BUYER_LESSEE = 'first time buyer/lessee';

export const VEHICLE_RETIREMENT = 'vehicle retirement';

export const RIDESHARE = 'rideshare';
